import { RESULTEVENT_TYPES, URLS } from "./constants";

import generateSessionToken from "../../shared/helpers/session_tokens";
import { json } from "../../shared/fetcher";

const SESSION_TOKEN = generateSessionToken();

function dispatchResultsEvent(type, data) {
  const resultsEvent = new CustomEvent(`${type}results`, { detail: { data } });

  document.body.dispatchEvent(resultsEvent);
}

function getUrl(href, params) {
  const searchStr = new URLSearchParams(params).toString();

  return this + href + (searchStr.length ? `?${searchStr}` : "");
}

async function autocomplete(query = "") {
  const params = query ? { q: query, token: SESSION_TOKEN } : undefined;
  const url = getUrl.call(this, URLS.autocomplete, params);
  let results;

  try {
    results = await json(url, { warn: true });
  } catch (e) {
    results = {};
  }

  dispatchResultsEvent(RESULTEVENT_TYPES.AUTOCOMPLETE, results);

  return results;
}

async function googlePlace(placeId) {
  const url = getUrl.call(this, URLS.googlePlace, { place_id: placeId, token: SESSION_TOKEN });
  let results;

  try {
    results = await json(url);
  } catch (e) {
    results = { error: e.message, url: e.url };
  }

  dispatchResultsEvent(RESULTEVENT_TYPES.GOOGLEPLACE, results);

  return results;
}

async function search(params) {
  const url = getUrl.call(this, URLS.search, params);
  let results;

  try {
    results = await json(url);
  } catch (e) {
    results = { error: e.message };
  }

  dispatchResultsEvent(RESULTEVENT_TYPES.SEARCH, results);

  return results;
}

function FrontendAPI(baseUrl = URLS.baseUrl) {
  const self = this;

  self.autocomplete = autocomplete.bind(baseUrl);
  self.googlePlace = googlePlace.bind(baseUrl);
  self.search = search.bind(baseUrl);
}

export default FrontendAPI;



// WEBPACK FOOTER //
// ./scripts/api/search.js